import React from 'react';

const OAuth2Icon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14 9V4H5V20H11.056C11.384 20.417 11.78 20.785 12.236 21.085L13.626 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3 2.455 3.449 2 4.002 2H14.997L21 8V9H14ZM12 11H21V16.949C21 17.939 20.499 18.865 19.664 19.414L16.5 21.498L13.336 19.414C12.9266 19.1461 12.5902 18.7807 12.357 18.3506C12.1238 17.9205 12.0012 17.4392 12 16.95V11ZM14 16.949C14 17.265 14.162 17.563 14.436 17.744L16.5 19.104L18.564 17.744C18.6969 17.6581 18.8064 17.5404 18.8825 17.4016C18.9586 17.2628 18.999 17.1073 19 16.949V13H14V16.949Z"
      fill="currentColor"
    />
  </svg>
);

export default OAuth2Icon;
